export class Storage {
    storage;
    constructor() {
        this.storage = new Map();
    }
    put(key, value) {
        this.storage.set(key, value);
    }
    get(key) {
        return this.storage.get(key);
    }
    remove(key) {
        return this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
    keys() {
        return Array.from(this.storage.keys());
    }
    length() {
        return this.storage.size;
    }
}
